import React from "react";
import { Box, Card, Skeleton } from "@mui/material";

export const StatCardSkeleton: React.FC = () => {
  return (
    <Card
      sx={{ border: "1px solid", borderColor: "divider", boxShadow: "none" }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
        }}
      >
        <Skeleton variant="circular" width={48} height={48} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: 1,
            }}
          >
            <Skeleton variant="text" width="40%" height={32} />
            <Skeleton variant="text" width="30%" height={20} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
